import FJWatermarkRemoverLeftContainer from './left/container/FJWatermarkRemoverLeftContainer';
import FJWatermarkRemoverRightContainer from './right/container/FJWatermarkRemoverRightContainer';

const FJWatermarkRemover = () => {
    return (
        <>
            <FJWatermarkRemoverLeftContainer />
            <FJWatermarkRemoverRightContainer />
        </>
    );
};

export default FJWatermarkRemover; 